import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";

// Inline "what the buyer will see" echo — the v1 stand-in for a full live
// buyer-checkout preview. Reinforces the receiver value the seller just typed,
// in the buyer's framing, so a wrong number is caught before it costs money.
// The value is wrapped in Unicode isolates (FSI…PDI) so an LTR number renders
// correctly inside the RTL sentence.
export function ReceiverEchoLine({ value }: { value: string }) {
  const t = useTranslations();
  const trimmed = value.trim();
  if (!trimmed) return null;
  const isolated = `⁨${trimmed}⁩`;
  return (
    <p className="text-xs font-medium leading-relaxed text-[color:var(--text-secondary)]">
      {t(keys.seller.pmWalletEcho, { value: isolated })}
    </p>
  );
}
